import { useEffect, useRef } from "react";
import { api } from "@/lib/api";

/** Generates a stable client id used for heartbeat and poll voting. */
function ensureClientId() {
  const KEY = "fi_client_id";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = `c-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
    localStorage.setItem(KEY, id);
  }
  return id;
}

/** Fires a heartbeat every 20s to backend so audience count can be computed. */
const AudienceHeartbeat = ({ channel = "radio" }) => {
  const idRef = useRef(ensureClientId());
  useEffect(() => {
    const send = () => {
      api.post("/audience/heartbeat", { session_id: idRef.current, channel }).catch(() => {});
    };
    send();
    const t = setInterval(send, 20000);
    return () => clearInterval(t);
  }, [channel]);
  return null;
};

export default AudienceHeartbeat;
export { ensureClientId };
